import EpisodeDate, { EpisodeDateProps } from './EpisodeDate';

export default EpisodeDate;
export type { EpisodeDateProps };
